import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import { isOvertimeTimed } from "../utils/overtime-utils";

export default class StartPeriod extends Fragment {
    constructor(period, periodLengthInSeconds) {
        super();

        this.period = period;
        this.periodLengthInSeconds = periodLengthInSeconds;
    }

    summarize(summaryContext, stringifier) {
        let periodAbbr = "QTR";
        let periodName = "Quarter";
        let period = this.period;
        let time = ` at ${stringifier.secondsToMMSS(
            this.periodLengthInSeconds
        )}`;
        if (
            this.period > summaryContext.gameConfig.general.periodsInRegulation
        ) {
            periodAbbr = "Overtime";
            periodName = "Overtime";
            period =
                this.period -
                summaryContext.gameConfig.general.periodsInRegulation;
            // Overtime is timed only while OT Time Control is on
            // (PSTATS-1268).
            if (!isOvertimeTimed(summaryContext.gameConfig)) {
                time = "";
            }
        }

        const message = `${stringifier.ordinalSuffix(
            period
        )} ${periodAbbr}${time}`;

        return new FragmentSummary(message, `Start of ${periodName}`);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }
}
